// @flow
import { createAction } from '@reduxjs/toolkit';

export const WS_CONNECT = 'WS_CONNECT';
export const WS_CONNECT_SUCCESS = 'WS_CONNECT_SUCCESS';
export const WS_CONNECT_ERROR = 'WS_CONNECT_ERROR';
export const WS_DISCONNECT = 'WS_DISCONNECT';
export const WS_DISPLAY_ERROR_LAYER = 'WS_DISPLAY_ERROR_LAYER';
export const WS_CALL_PENDING = 'WS_CALL_PENDING';
export const WS_CLEAR_PENDING = 'WS_CLEAR_PENDING';
export const WS_CLEAR_RESPONSES = 'WS_CLEAR_RESPONSES';
export const WS_GET_RECAPTCHA = 'WS_GET_RECAPTCHA';
export const WS_GET_RECAPTCHA_SUCCESS = 'WS_GET_RECAPTCHA_SUCCESS';
export const GET_CAPTCHA = 'GET_CAPTCHA';
export const SET_CAPTCHA = 'SET_CAPTCHA';
export const WS_READY = 'WS_READY';
export const WS_CONNECT_DEPOSIT = 'WS_CONNECT_DEPOSIT';
export const WS_CONNECT_DEPOSIT_SUCCESS = 'WS_CONNECT_DEPOSIT_SUCCESS';
export const WS_DISCONNECT_DEPOSIT = 'WS_DISCONNECT_DEPOSIT';

export const clearResponses = createAction(WS_CLEAR_RESPONSES);

export const clearPending = createAction(WS_CLEAR_PENDING);
